import { css } from "@emotion/react"

const Largest = props => css`
  font-family: Unica77, NeueHaasUnicaW1G, neue-haas-unica, sans-serif;
  font-size: 38px;
  font-weight: 300;
  line-height: 38px;
  letter-spacing: normal;
`

const Large = props => css`
  font-family: Unica77, NeueHaasUnicaW1G, neue-haas-unica, sans-serif;
  font-size: 24px;
  font-weight: 300;
  line-height: 30px;
  letter-spacing: -0.5px;
`

const Medium = props => css`
  font-family: Unica77, NeueHaasUnicaW1G, neue-haas-unica, sans-serif;
  font-size: 18px;
  font-weight: 300;
  line-height: 1.22;
  letter-spacing: normal;
`

const Base = props => css`
  font-family: Unica77, NeueHaasUnicaW1G, neue-haas-unica, sans-serif;
  font-size: 16px;
  font-weight: 300;
  line-height: 21.3px;
  letter-spacing: -0.25px;
`

const Small = props => css`
  font-family: Unica77, NeueHaasUnicaW1G, neue-haas-unica, sans-serif;
  font-size: 14px;
  font-weight: 300;
  line-height: 14px;
  letter-spacing: 0px;
`

export default {
  Largest,
  Large,
  Medium,
  Base,
  Small,
}
